import { CHAT_MESSAGE_STATUS } from "@/utils/constants";
import { isMyMessage } from "@/utils/helpers";

/** Retorna o próximo status se a transição for válida (um passo à frente na ordem), senão undefined. */
export const chatMessageStatusUpdater = (
  from: string,
  to: string,
): string | undefined => {
  const orderedStatus = [...Object.values(CHAT_MESSAGE_STATUS).slice(1)];
  const [numFrom, numTo] = [
    orderedStatus.findIndex((status) => status === from),
    orderedStatus.findIndex((status) => status === to),
  ];

  if (numFrom !== numTo && numTo === numFrom + 1) return to;
  return undefined;
};

/** Retorna o índice da primeira mensagem que ainda não foi lida. */
export const findFirstChatMessagePendingStatus = (
  source: Array<{ statusMessage?: string }>,
): number =>
  [...source].findIndex(
    (message) =>
      message.statusMessage !== CHAT_MESSAGE_STATUS.read &&
      message.statusMessage !== "0",
  );

/** Separa atualizações de status entre mensagens próprias e de outros participantes. */
export const chatMessageStatusByOwner = (
  source: Array<{
    id: string;
    senderId?: string;
    [key: string]: string | undefined;
  }> = [],
  currentChatId: string,
  myId: number,
) => {
  return source.reduce(
    (acc, status) => {
      if (status.id !== currentChatId) return acc;
      if (!status.senderId || isMyMessage(status.senderId, myId))
        acc.myStatus.push(status);
      else acc.othersStatus.push(status);
      return acc;
    },
    { myStatus: [] as typeof source, othersStatus: [] as typeof source },
  );
};
